/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

import WidgetWrapper from 'components/Widgets/WidgetWrapper/WidgetWrapper';
import WidgetPlaceHolder from 'containers/Dashboard//Popups/components/Stepper/helpers/components/WidgetPlaceHolder';
import { WidgetSkeleton } from 'components/Widgets/WidgetWrapper/components';

export const findWidgetForGridSlot = ({
  widgets,
  updateWidget,
  isDashboardLoading,
  dashboardData,
  isEditMode,
  dispatchCannedDashboardList,
  baseWidgetPlaceHolder,
  setWhichPopup,
  setPanelIndex,
  panelIndex,
  slot,
  dateState
}) => {
  const targetWidget = !isDashboardLoading && widgets.find(widget => widget.panelIndex === slot);

  if (!targetWidget && isEditMode) {
    return (
      <WidgetPlaceHolder
        baseWidgetPlaceHolder={baseWidgetPlaceHolder}
        setWhichPopup={setWhichPopup}
        setPanelIndex={setPanelIndex}
        panelIndex={panelIndex}
        slot={slot}
      />
    );
  }

  if (isDashboardLoading) {
    return <WidgetSkeleton />;
  }

  if (!targetWidget) {
    return null;
  }

  return (
    <WidgetWrapper
      widget={targetWidget}
      updateWidget={updateWidget}
      isDashboardLoading={isDashboardLoading}
      dashboardData={dashboardData}
      dispatchCannedDashboardList={dispatchCannedDashboardList}
      isEditMode={isEditMode}
      globalPickerDateState={dateState}
    />
  );
};

findWidgetForGridSlot.propTypes = {
  isDashboardLoading: PropTypes.bool.isRequired,
  updateWidget: PropTypes.func.isRequired,
  dispatchCannedDashboardList: PropTypes.func.isRequired,
  dashboardData: PropTypes.shape({}).isRequired,
  widgets: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      colSpan: PropTypes.number.isRequired,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      dateRangeType: PropTypes.string,
      dateMatchType: PropTypes.number.isRequired,
      customDateMatchType: PropTypes.number.isRequired,
      isChartTooltipDisplayed: PropTypes.bool.isRequired,
      isTitleDisplayed: PropTypes.bool.isRequired,
      isDateDisplayed: PropTypes.bool.isRequired,
      isLegendDisplayed: PropTypes.bool.isRequired,
      id: PropTypes.string.isRequired,
      dateRangeTypeId: PropTypes.number.isRequired,
      masterObjectId: PropTypes.number.isRequired,
      masterObjectTypeId: PropTypes.number,
      overlay: PropTypes.shape({
        baseWidget: PropTypes.shape({
          name: PropTypes.string.isRequired,
          widgetType: PropTypes.shape({
            name: PropTypes.string.isRequired
          }).isRequired
        }).isRequired
      }).isRequired
    }).isRequired
  ).isRequired,
  isEditMode: PropTypes.bool,
  baseWidgetPlaceHolder: PropTypes.string,
  setWhichPopup: PropTypes.func,
  setPanelIndex: PropTypes.func,
  slot: PropTypes.number.isRequired,
  panelIndex: PropTypes.number
};

findWidgetForGridSlot.defaultProps = {
  isEditMode: false,
  baseWidgetPlaceHolder: null,
  setWhichPopup: null,
  setPanelIndex: null,
  panelIndex: null
};
